import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';
import { connect } from 'react-redux';

import ConnectedSearchForm from './SearchForm';
import HandleReservations from './HandleReservations';
import ReservationsList from '../../commonComponents/ReservationsList';
import ReservationTTOO from './ReservationTTOO';

import { reservationTTOOType } from '../models/Reservation.model';

const MainContainer = (props) => {
  const [ searchDone, setSearchAction ] = useState(false);
  const [ existsUnsavedChanges, setUnsavedIndicator ] = useState(false);

  useEffect(() => {
    const { unsavedReservationsList } = props;

    let isDirty = false;

    if (searchDone && unsavedReservationsList.length > 0) isDirty = true;

    setUnsavedIndicator(isDirty);
  }, [props.unsavedReservationsList]); // eslint-disable-line react-hooks/exhaustive-deps

  const {
    hotel,
    operator,
    locatorTTOO,
    reservationsList,
    addNewReservation
  } = props;

  const handleNewReservation = () => {
    const extraDataTTOO = { hotel, operator, locatorTTOO };

    addNewReservation(extraDataTTOO);
  };

  return (
    <Container className="no-padding">
      <ConnectedSearchForm handleSearchAction={setSearchAction} lockSearchForm={existsUnsavedChanges} />
      {(searchDone) &&
        <>
          <HandleReservations
            handleNewReservation={handleNewReservation}
          />
          <ReservationsList reservationsList={reservationsList}>
            <ReservationTTOO />
          </ReservationsList>
        </>
      }
    </Container>
  );
};

MainContainer.propTypes = {
  reservationsList: PropTypes.object,
  unsavedReservationsList: PropTypes.arrayOf(PropTypes.number),
  addNewReservation: PropTypes.func
};

MainContainer.defaultProps = {
  reservationsList: {},
  unsavedReservationsList: [],
  addNewReservation: () => {}
};

const mapStateToProps = state => ({
  reservationsList: state.reservations.reservationsList,
  unsavedReservationsList: state.reservations.unsavedReservations,
  hotel: state.tourOperation.hotel,
  operator: state.tourOperation.operator,
  locatorTTOO: state.tourOperation.locatorTTOO
});

const mapDispatchToProps = dispatch => ({
  addNewReservation: (extraDataTTOO) => {
    dispatch({
      type: 'ADD_NEW_RESERVATION',
      reservationType: reservationTTOOType,
      reservationExtraData: extraDataTTOO
    });
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MainContainer);
export { MainContainer, mapStateToProps, mapDispatchToProps }
